import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { dashboardTab, getSidebar } from './index';
import { SidebarNotification } from '../../common/SidebarNotification';
import { putToConversationStore } from '../../actions/conversations';
import { useDispatch } from 'react-redux';
import { isBranchUser, isCustomer, isScm } from '../../utils/role';
import { isMobileView } from '../../utils/utils';

const Sidebar = ({ mainChatContanerRef }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const {
        loggedUser: {
            role: { id: role },
            type,
            frontend_controller,
            grafana_url,
            manage_partner_payments
        },
    } = useSelector((state) => state.auth);

    const newLoggedUserData = useSelector((state) => state.auth.newLoggedUserData);
    const sidebarList = useSelector((state) => state.utils.sidebarList);

    const [togglemenu, setToggleMenu] = useState(true);
    const sidebar = getSidebar(sidebarList, { grafana_dashboard_url: newLoggedUserData.org.grafana_dashboard_url, org_id: newLoggedUserData.org.id });

    const togglemenumob = () => {
        setToggleMenu(!togglemenu);
        if (togglemenu) {
            mainChatContanerRef.current.classList.add('mainContainerMobileView')
            mainChatContanerRef.current.classList.remove('mainContainer')
        } else {
            mainChatContanerRef.current.classList.remove('mainContainerMobileView')
            mainChatContanerRef.current.classList.add('mainContainer')
        }

    };

    const showChatGpt = false;
    return (
        <>
            <div className='xl:hidden fixed z-75 bottom-10 left-4 bg-scogoprimary h-14 w-14 leading-12 rounded-full shadow-lg flex items-center justify-center cursor-pointer hover:bg-scogosecondary active:scale-95 transition-all duration-200' onClick={togglemenumob}>
                <img
                    src={process.env.PUBLIC_URL + '/assets/icons/menu-icon.svg'}
                    alt="Menu"
                    className='h-6 w-6 text-white'
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGNsYXNzPSJoLTYgdy02IiBmaWxsPSJub25lIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHN0cm9rZT0id2hpdGUiPjxwYXRoIHN0cm9rZUxpbmVjYXA9InJvdW5kIiBzdHJva2VMaW5lam9pbj0icm91bmQiIHN0cm9rZVdpZHRoPSIyIiBkPSJNNCA2aDE2TTQgMTJoOG0tOCA2aDE2Ii8+PC9zdmc+';
                    }}
                />
            </div>
            {togglemenu ? (
                <div className={`sidebar text-center fixed flex flex-col justify-between`} >
                    <div>
                        {sidebar?.map((item, index) => {
                            const isSelected = location.pathname?.startsWith(item.Linkto);

                            const handleClick = () => {
                                navigate('/dashboard');
                            }

                            if (item.Linkto === dashboardTab.Linkto) {
                                return <div onClick={handleClick} className="hover:font-medium  hover:text-scogoprimary block 2xl:py-4 py-2 hover:bg-blue-100 cursor-pointer">
                                    <div className="relative">
                                        <img
                                            fill="#ffff"
                                            className="sidebarIcons text-scogoprimary material-icons"
                                            alt=""
                                            src={process.env.PUBLIC_URL + item.imgSrc}
                                        />
                                    </div>
                                    <p className="mt-1 sidebarFont">
                                        {typeof item.name === 'function'
                                            ? item.name(role, type, frontend_controller, manage_partner_payments)
                                            : item.name}
                                    </p>
                                </div>
                            }
                            return (
                                <div key={index} className='relative'>
                                    {isSelected && <span className='border-scogoprimary border-l-4 absolute left-0 h-full'></span>}
                                    <Link
                                        to={item.Linkto}
                                        target={item?.target}
                                        className={isSelected ? 'block py-2 bg-blue-100' : 'block py-2 hover:bg-blue-100'}
                                    >
                                        <div className='relative'>
                                            <img
                                                fill='#ffff'
                                                className={
                                                    isSelected ? 'sidebarIcons text-scogoprimary material-icons ' : 'sidebarIcons text-scogogray material-icons '
                                                }
                                                alt=''
                                                src={process.env.PUBLIC_URL + item.imgSrc}
                                            />
                                            {item.countKey && <SidebarNotification countKey={item.countKey} />}
                                        </div>
                                        <p
                                            className={
                                                isSelected ? 'text-scogoprimary mt-1 font-medium sidebarFont' : 'text-scogogray mt-1 font-medium sidebarFont'
                                            }
                                        >
                                            {typeof item.name === 'function' ? item.name(role, type, frontend_controller, manage_partner_payments) : item.name}
                                        </p>
                                    </Link>
                                </div>
                            );
                        })}
                    </div>
                    {showChatGpt && !isMobileView && <div className='w-full flex justify-center' style={{ marginBottom: isMobileView ? '5rem' : '2rem' }}>
                        <ChatGptSvg />
                    </div>}
                </div >
            ) : null}

        </>
    );
};

export default Sidebar;


const ChatGptSvg = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { messageQueueList } = useSelector((state) => state.conversations);

    const onScogoGptClick = () => {
        navigate('/chats?chatGpt=true')
        dispatch(putToConversationStore({
            openedConversationId: 'scogo_new_chat_created',
            messageQueueList: {
                ...messageQueueList, 'scogo_new_chat_created': []
            }
        }));
    }
    return <div onClick={onScogoGptClick} className='flex justify-center drop-shadow-xl cursor-pointer  hover:-translate-y-1 hover:scale-110 duration-300' >
        <img className='h-16' src={process.env.PUBLIC_URL + '/img/sia_logo.png'} alt='' />
    </div >
}